module.exports = __webpack_public_path__ + "img/landing_btn_again.1dfda22e.png";